module.exports = __webpack_public_path__ + "static/media/rain_dance.7e420e06.jpeg";